import fetch from 'isomorphic-fetch';
import { config } from '../../../../core/config/config';
import store from '../../../../core/redux/store';

export const grantDeliveryMap = async (
  client_id: string,
  delivery_map_enabled: boolean
): Promise<any> => {
  try {
    const state = store.getState();
    const token = state.token.token;
    console.log('delivery_map_enabled', delivery_map_enabled);
    const uri = `${config.uri.base_url}/clients/${encodeURIComponent(
      client_id
    )}/grant-delivery-map`;
    const options = {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify({ delivery_map_enabled })
    };

    const response = await fetch(uri, options);
    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Something went wrong');
    }

    return result;
  } catch (err) {
    throw err;
  }
};
